const baseUrl = "https://static.vivamoselcampo.co/uploads/vec_team";
const prizesList = [
  {
    name: 'Douglas Jairo Velásquez',
    image: `${baseUrl}/douglas-velasquez.jpg`,
    role: 'Líder de proyecto'
  },
  {
    name: 'Daniel Augusto Cardozo C.',
    image: `${baseUrl}/daniel-cardozo.jpg`,
    role: 'Desarrollador de Software'
  },
  {
    name: 'María Elena Liberato',
    image: `${baseUrl}/elena-liberato.jpg`,
    role: 'Coordinadora Administrativa'
  },
  {
    name: 'Javier Orlando Velásquez',
    image: `${baseUrl}/javier-velasquez.jpg`,
    role: 'Asesor de Arquitectura'
  },
];

export default prizesList;



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/vecTeamList.js